( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

$.ui = $.ui || {};

return $.ui.version = "1.13.2";

} );



// WEBPACK FOOTER //
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/jquery-ui/ui/version.js